export default [
  {
    title: 'Applications',
    icon: 'GridIcon',
    tagVariant: 'light-warning',
    route: "home",
  },
  {
    title: 'Security Logs',
    icon: 'ActivityIcon',
    tagVariant: 'light-warning',
    route: "security-logs",
    childrenNestedRoutes: []
  },
  {
    title: 'Ministers',
    icon: 'UserPlusIcon',
    tagVariant: 'light-warning',
    route: "ministers",
    permissions: ["ministers:CanList"],
  },
  {
    title: 'Members',
    icon: 'UsersIcon',
    tagVariant: 'light-warning',
    route: "members",
    permissions: ["member_profiles:CanList"],
  },
  // Removed extra section headers that only appeared on mobile (vertical menu)
  {
    header: 'Membership',
    icon: 'SlidersIcon',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'Types',
        icon: 'UsersIcon',
        tagVariant: 'light-warning',
        route: "member-types",
        permissions: ["member_types:CanList"],
        childrenNestedRoutes: []
      },
      {
        title: 'Titles',
        icon: 'UsersIcon',
        tagVariant: 'light-warning',
        route: "member-titles",
        permissions: ["member_titles:CanList"],
        childrenNestedRoutes: []
      },
      {
        title: 'Designations',
        icon: 'UsersIcon',
        tagVariant: 'light-warning',
        route: "member-designations",
        permissions: ["member_designations:CanList"],
        childrenNestedRoutes: []
      },
      {
        title: 'Departments',
        icon: 'LayoutIcon',
        tagVariant: 'light-warning',
        route: "departments",
        permissions: ["departments:CanList"],
        childrenNestedRoutes: []
      },
      {
        title: 'Member Status',
        icon: 'LayoutIcon',
        tagVariant: 'light-warning',
        route: "member-status",
        permissions: ["member_status:CanList"],
        childrenNestedRoutes: []
      },
    ]
  },
  
  {
    header: 'Settings',
    icon: 'SettingsIcon',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'General',
        icon: 'SettingsIcon',
        tagVariant: 'light-warning',
        route: "admin-settings",
        permissions: ["settings:CanList"],
      },
      {
        title: 'Sample CSV Files',
        icon: 'FileIcon',
        tagVariant: 'light-warning',
        route: "admin-sample-csv-files",
        permissions: ["sample_csv_files:CanList"],
      },
      {
        title: 'Applications',
        icon: 'GridIcon',
        tagVariant: 'light-warning',
        route: "applications",
        permissions: ["applications:CanList"],
      },
    ],
    childrenNestedRoutes: [
      'admin-new-sample-csv-file',
      'admin-update-sample-csv-file'
    ]
  },
  {
    header: 'Geo Data',
    icon: 'MapIcon',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'Church Map',
        icon: 'SettingsIcon',
        tagVariant: 'light-warning',
        route: "admin-church-map",
        permissions: ["church_map:CanList"],
      },
      {
        title: 'Ghana Regions',
        icon: 'MapPinIcon',
        tagVariant: 'light-warning',
        route: "regions",
        permissions: ["regions:CanList"],
      },
      {
        title: 'Mission Blocs',
        icon: 'GlobeIcon',
        tagVariant: 'light-warning',
        route: "mission-blocks",
        permissions: ["mission_blocks:CanList"],
      },
      {
        title: 'RMCs',
        icon: 'CompassIcon',
        tagVariant: 'light-warning',
        route: "rmcs",
        permissions: ["rmc:CanList"],
      },
      {
        title: 'Countries',
        icon: 'FlagIcon',
        tagVariant: 'light-warning',
        route: "countries",
        permissions: ["countries:CanList"],
      },
      {
        title: 'Areas',
        icon: 'Navigation2Icon',
        tagVariant: 'light-warning',
        route: "areas",
        permissions: ["areas:CanList"],
      },
      {
        title: 'Districts',
        icon: 'NavigationIcon',
        tagVariant: 'light-warning',
        route: "districts",
        permissions: ["districts:CanList"],
      },
      {
        title: 'Assemblies',
        icon: 'GridIcon',
        tagVariant: 'light-warning',
        route: "assemblies",
        permissions: ["assemblies:CanList"],
      },
    ],
    childrenNestedRoutes: []
  },
  {
    header: 'IAM',
    icon: 'MinusCircleIcon',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'Resources',
        icon: 'BoxIcon',
        tagVariant: 'light-warning',
        route: "admin-resources",
        permissions: ["resource:CanList"],
      },
      {
        title: 'Policies',
        icon: 'LockIcon',
        tagVariant: 'light-warning',
        route: "admin-policies",
        permissions: ["policy:CanList"],
      },
      {
        title: 'Roles',
        icon: 'LockIcon',
        tagVariant: 'light-warning',
        route: "admin-user-roles",
        permissions: ["user_role:CanList"],
      },
      {
        title: 'Users',
        icon: 'UsersIcon',
        tagVariant: 'light-warning',
        route: "users",
        permissions: ["users:CanList"],
      },

    ],
    childrenNestedRoutes: [
      'users',
      'admin-resources',
      'admin-new-resource',
      'admin-update-resource',
      'admin-resource-actions',
      'admin-new-resource-action',
      'admin-update-resource-action',
      'admin-policies',
      'admin-new-policy',
      'admin-user-roles',
      'admin-view-policies',
      'new-user-role',
      'admin-update-user-role',
    ]
  },
  
  {
    header: 'Logs',
    icon: 'ListIcon',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'User Logs',
        icon: 'ListIcon',
        route: "logs",
        tagVariant: 'light-warning',
        permissions: ["logs:CanList"]
      },
      {
        title: 'Audit Trail',
        route: "audit-trail",
        icon: 'GitBranchIcon',
        tagVariant: 'light-warning',
        permissions: ["audit_trail:CanList"]
      },
    ],
    childrenNestedRoutes: [
      'logs',
      'audit-trail'
    ]
  },
]
